<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>
    <v-sheet color="backgroundGrayColor" height="auto" style="border: solid rgb(220, 220, 220);">
      <v-container class="mx-auto" style="max-width: 1100px;">
        <v-container pb-12>
          <p class="pt-3">社用携帯に関するお知らせはこちらから確認して下さい。</p>
          <p class="pb-6">社用携帯の電話番号や所持者一覧は
            <router-link :to="{ name: 'cellPhoneList' }" target="_blank">こちら</router-link>
            から確認して下さい。
          </p>
          <!--step1-->
          <v-row class="pt-6">
            <v-expansion-panels accordion v-model="panel1" id="step1">
              <v-expansion-panel>
                <v-responsive>
                  <v-expansion-panel-header class="text-h5">
                    【盗難・紛失発生時】
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content>
                  <ul class="explanation__list">
                    <li v-for="(item, index) in theftCaseUsage" :key="index"
                        class="px-4 mt-6"
                        v-html="item"
                    >
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <!--step2-->
          <v-row class="pt-6">
            <v-expansion-panels accordion v-model="panel2" id="step2">
              <v-expansion-panel>
                <v-responsive>
                  <v-expansion-panel-header class="text-h5">
                    【メールについて】
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="py-3">
                  <ul class="explanation__list">
                    <li class="px-4">予め設定されている<span class="d-inline-block">メール機能以外使用禁止です。</span><span
                        class="d-inline-block">（@softbank等のキャリアメール）</span></li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <!--step3-->
          <v-row class="pt-6">
            <v-expansion-panels accordion v-model="panel3" id="step3">
              <v-expansion-panel>
                <v-responsive>
                  <v-expansion-panel-header class="text-h5">
                    【社用携帯に関するお知らせ】
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="py-6">
                  <ul class="explanation__heading__list mb-6 text-h6">
                    <li class="px-4">
                      最新のお知らせ
                    </li>
                  </ul>
                  <p v-for="(item, index) in officeCellphoneUsage" :key="`first-${index}`"
                     class="px-8 mt-3"
                     v-html="item"
                  >
                  </p>
                  <ul class="explanation__heading__list font-weight-bold mt-12 text-h6">
                    <li class="px-4">
                      常にWi-FiはONにしておく
                    </li>
                  </ul>
                  <v-img src="@/assets/iphone-ipad-wifi-turn-on-off.png" class="notice__img mx-8 mt-3 mb-12"
                         max-width="200px" style="min-height: 200px; width: auto;"></v-img>
                  <p v-for="(item, index) in wifiUsage" :key="`second-${index}`"
                     class="px-8 mt-3"
                     v-html="item"
                  >
                  </p>
                  <ul class="explanation__heading__list font-weight-bold mt-12 text-h6">
                    <li class="px-4">
                      必要のない時はテザリングを使用しない
                    </li>
                  </ul>
                  <p class="px-8">特にテザリングでPCへ接続するとあっという間に上限を超えます。</p>
                  <ul class="explanation__heading__list font-weight-bold mt-12 text-h6">
                    <li class="px-4">
                      私用に利用しない
                    </li>
                  </ul>
                  <p v-for="(item, index) in privateUseUsage" :key="`third-${index}`"
                     class="px-8 mt-6"
                     v-html="item"
                  >
                  </p>
                  <p class="px-8 mt-12">以上ご協力の程、何卒よろしくおねがいします。</p>
                  <p class="px-8">問合先：総務チーム</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-container>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import Title from '../components/Title';

export default {
  name: 'CellPhoneView',
  components: {
    Title,
  },
  data() {
    return {
      title: '社用携帯に関するお知らせ',
      img: 'title_cellPhone.svg',

      //デフォルトでパネルを開くための値
      panel1: 0,
      panel2: 0,
      panel3: 0,

      //目次
      theftCaseUsage: [
        '「<router-link :to="{ name: \'manual\'}" target="_blank">申請書・マニュアル</router-link>」ページから以下を参考に、各所への連絡&端末のロックを行ってください。',
        '「総務関連」> 「20180219_会社スマホ盗難・紛失時の対応フロー.pdf」',
        '「総務関連」> 「社用携帯紛失時対応マニュアル20170830.pdf」',
      ],

      //社用携帯
      officeCellphoneUsage: [
        '社用携帯所持者　各位',
        'お疲れ様です。',
        '皆様へパケット通信料節約のお願いの為、ご連絡させていただきます。',
        '社用携帯のデータ容量制限には限りがあります。',
        'また、社用携帯全てのデータ容量を全員でシェアしていますので、',
        '<span class="font-weight-bold text-decoration-underline">誰かが大量に使用するとそのほかのメンバー全員に影響が出ます。</span>',
        '特に現在はポケドク営業デモに一部のメンバーが使用しているため、',
        '「<span class="font-weight-bold">制限がかかってデモが出来ない</span>」等実際に影響が出ています。',
        'その為、みなさんに協力して頂く必要があります。',
        '以下にパケット節約方法を記載しましたのでご協力ください。',
      ],

      //wi-fi
      wifiUsage: [
        '社用携帯には全てMRT社内のWi-Fiに接続できるよう設定しています。',
        '社内にいるときは常時Wi-FiをONにしてください。',
        '<span class="red--text">接続できない場合すぐ総務チームへ相談してください。</span>',
      ],

      //私用禁止
      privateUseUsage: [
        '<span class="red--text">業務上必要のないアプリや機能は一切禁止します！</span>',
        '（例、ちょっとYoutubeで動画を見る、出前を頼むためにウーバーイーツを使用する、ゲームアプリを使う、LINEで電話をする等々）',
        '特に影響が大きいと思われるのが「<span class="red--text">LINE電話</span>」の使用です。',
        '社用携帯は通話かけ放題の契約です。極力「<span class="red--text">電話機能</span>」を使用して下さい！',
        '本来LINEアプリの使用は禁止ですが、黙認しているものという認識のもと使用して下さい。（許可されているわけではありません）',
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.v-expansion-panels {
  border: 2px solid #ffffff;
  border-radius: 4px;
}

.v-expansion-panels:hover {
  border: 2px solid #0095D9;
  border-radius: 4px;
}

.explanation__list li {
  position: relative;
  list-style: none;

  &:before {
    content: '';
    width: 10px;
    height: 1px;
    background-color: #d70e19;
    position: absolute;
    top: 10px;
    left: 0;
  }
}

.explanation__heading__list li {
  position: relative;
  list-style: none;

  &:before {
    content: '';
    width: 10px;
    height: 1px;
    background-color: #d70e19;
    position: absolute;
    top: 14px;
    left: 0;
  }
}

.explanation__detailList li {
  list-style: unset;

  &:before {
    display: none;
  }
}

.notice__img {
  border: solid #717170;
}

.v-expansion-panel--active {
  border: 2px solid #0095D9;
  border-radius: 2px;
}
</style>